export enum Role {
  FAE = 'ITEM_360_FAE',
  SALES = 'ITEM_360_SALES',
  PM = 'ITEM_360_PM',
  ADMIN = 'ITEM_360_ADMIN',
  CSR = 'ITEM_360_CSR',
  PCSR = 'ITEM_360_PCSR',
}
